import store from '@/store'

/**
 * v-permission 指令：基于当前用户权限码控制元素显隐。
 * 用法：
 *   v-permission="'merchant:add'"            // 单个权限码
 *   v-permission="['merchant:add','merchant:edit']"  // 命中任一即显示
 * 无权限时移除该元素。
 */
export default {
  inserted(el, binding) {
    check(el, binding)
  },
  update(el, binding) {
    check(el, binding)
  }
}

function check(el, binding) {
  const { value } = binding
  if (!value) return
  const codes = Array.isArray(value) ? value : [value]
  const owned = store.getters.permissions || []
  const ok = codes.some(c => owned.indexOf(c) !== -1)
  if (!ok && el.parentNode) {
    el.parentNode.removeChild(el)
  }
}
